import React, { useState } from 'react'
import { connect } from 'react-redux'

import ChatFileUploadView from '../component/ChatFileUploadView'
import ChatFileUploadTypeButton from '../blocks/ChatFileUploadTypeButton'
import { CHAT_MESSAGE_TYPES } from '../../../../shared/constants'
import { showReduxModal } from '../../../../Reducers/UI/actions'

const ChatFileUpload = ({ onFileUpload, showReduxModal }) => {
  const [isActive, setIsActive] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const toggleIsActive = () => setIsActive(!isActive)

  const onError = error => {
    showReduxModal({
      title: 'Upload failed',
      children: `Reason: ${JSON.stringify(error)}`,
      confirmLabel: `OK`,
      hideCancel: true,
    })
  }

  const onUpload = async ({ event, type }) => {
    const file = event.target.files[0]

    if (!file) return

    setIsLoading(true)

    try {
      await onFileUpload({ type, file })
    } catch (error) {
      onError(error)
      console.error(error)
    } finally {
      setIsActive(false)
      setIsLoading(false)
    }
  }

  return (
    <ChatFileUploadView
      isActive={isActive}
      toggleIsActive={toggleIsActive}
      isLoading={isLoading}
    >
      <ChatFileUploadTypeButton
        type={CHAT_MESSAGE_TYPES.IMAGE}
        onChange={event => onUpload({ type: CHAT_MESSAGE_TYPES.IMAGE, event })}
      />
      <ChatFileUploadTypeButton
        type={CHAT_MESSAGE_TYPES.VIDEO}
        onChange={event => onUpload({ type: CHAT_MESSAGE_TYPES.VIDEO, event })}
      />
      <ChatFileUploadTypeButton
        type={CHAT_MESSAGE_TYPES.FILE}
        onChange={event => onUpload({ type: CHAT_MESSAGE_TYPES.FILE, event })}
      />
    </ChatFileUploadView>
  )
}

const mapDispatchToProps = { showReduxModal }

export default connect(
  null,
  mapDispatchToProps,
)(ChatFileUpload)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatFileUpload/container/ChatFileUpload.js